import styled from 'styled-components';

import { OptimisticPublicationDate } from '@xing-com/crate-jobs-components-optimistic-publication-date';
import { mediaConfined } from '@xing-com/layout-tokens';
import { scale150, spaceL, spaceS } from '@xing-com/tokens';

type Props = {
  date?: string;
};

const StyledPublicationDate = styled(OptimisticPublicationDate)`
  white-space: nowrap;
  height: ${scale150};
  line-height: ${scale150};
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }

  &:empty {
    display: none;
  }
`;

export const PublishedDate: React.FC<Props> = ({ date }) => {
  if (!date) return null;
  return (
    <StyledPublicationDate
      data-testid="job-details-published-date"
      date={date}
    />
  );
};
